import { Collection } from '../collection/collection';

export function collect<T>(items: Array<T>) {
    return new Collection<T>(items);
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/collection.ts